// Toggle country dropdown if clicking the selector
$('.country-drop .selected-country').click(function click() {
  const $this = $(this);
  $this.siblings('ul').slideToggle();

  const $icon = $this.find('.js-current-lang');
  $icon.toggleClass('is-active');
});

// Don't do anything if we click inside the country dropdown
$('.country-drop').click((e) => {
  e.stopPropagation();
});

// Close the country dropdown if clicking outside
$(document).click(() => {
  const $toggle = $('.country-drop ul');
  if ($toggle.is(':visible')) {
    const $icon = $toggle.find('i.fa');
    $icon.removeClass('fa-chevron-down');
    $icon.removeClass('fa-chevron-up');
    $icon.addClass('fa-chevron-down');

    $toggle.slideUp();
  }
});
